import { AxiosError } from 'axios';
import { EXPRESS_API } from 'configs/api/expressApi';
import { errorToast } from 'lib/components/toasts/error';
import { useMutation, useQueryClient } from 'react-query';

const isSafeVideoId = (id: string): boolean => /^[a-zA-Z0-9_-]+$/.test(id);

export const deleteVideoWithRO = async (videoId: string) => {
  if (!isSafeVideoId(videoId)) {
    throw new Error('Invalid video ID');
  }
  const response = await EXPRESS_API.put(
    `/video-requests/${videoId}/delete-with-ro`
  );
  return response.data;
};

export const useDeleteVideoWithROMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(deleteVideoWithRO, {
    onSuccess: () => {
      queryClient.invalidateQueries('cds-videos');
    },
    onError: (error: AxiosError<{ message: string }>) => {
      const errorMsg = error.response?.data?.message || 'Error deleting video';
      errorToast({
        title: errorMsg,
      });
    },
  });
};
